<template>
    <v-app id="inspire" :class="layoutFlag ? 'defaultApp' : 'modalApp'">
        <v-app-bar
            app
            elevation="3"
            height="84"
            clipped-left
            color="#4E87DD"
            v-if="layoutFlag"
            style="z-index: 198"
        >

            <v-app-bar-nav-icon color="white" @click="drawer = !drawer" style="opacity:0.5; "></v-app-bar-nav-icon>

            <v-toolbar-title>
                <v-img
                    width="27"
                    height="30"
                    src="/img/admin_logo.png"
                    @click="goDashboard"
                    style=" margin-right:218px;"
                ></v-img>
            </v-toolbar-title>

            <div class="flex-grow-1"></div>
            <v-btn small text class="white--text font-text-mid" @click="openChangePassword">{{ userName }}: {{ userId }}</v-btn>
            <span class="white--text font-text-mid">|</span>
            <v-btn small text class="white--text font-text-mid" v-on:click="doLogout">LOGOUT
                <v-icon class="ml-2">mdi-power</v-icon>
            </v-btn>
        </v-app-bar>

        <v-navigation-drawer
            app
            clipped
            v-model="drawer"
            width="295"
            style="background-color:#F4F6F8; z-index: 197;"
            floating
            v-if="layoutFlag"
        >

            <v-divider class="mb-6"></v-divider>

            <left-menu>
            </left-menu>

        </v-navigation-drawer>

        <v-main>
            <router-view></router-view>

            <main-footer v-if="layoutFlag" ref="mainFooter"></main-footer>
        </v-main>


        <v-dialog v-model="popupModal" persistent max-width="500" @keydown.esc="closePopup()">
            <v-flex v-if="popupType === 'alert'">
                <popup-alert v-on:close="closePopup"></popup-alert>
            </v-flex>
            <v-flex v-if="popupType === 'confirm'">
                <popup-confirm v-on:ok="okPopup" v-on:close="closePopup"></popup-confirm>
            </v-flex>
            <v-flex v-if="popupType === 'addrBook'">
                <popup-addr-book v-on:ok="okPopup" v-on:close="closePopup"></popup-addr-book>
            </v-flex>
            <v-flex v-if="popupType === 'changePassword'">
                <popup-change-password :userId="userId" v-on:close="closePopup"></popup-change-password>
            </v-flex>
        </v-dialog>
    </v-app>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'App',
    components: {
        'LeftMenu': () => import('@/components/common/left_menu'),
        'MainFooter': () => import('@/components/common/main_footer'),
        'PopupAlert': () => import('@/components/common/popup_alert'),
        'PopupConfirm': () => import('@/components/common/popup_confirm'),
        'popupAddrBook': () => import('@/components/common/popup_addr_book'),
        'PopupChangePassword': () => import('@/components/common/popup_change_password.vue'),
    },
    data: () => ({
        drawer: null,
        managerName: '관리자',
        managerId: 'CallGate',
        modal: null,
    }),
    computed: {
        ...mapGetters({
            isAuthenticated: 'login/isAuthenticated',
            authUser: 'login/getAuthUser',
            accessToken: 'login/getAccessToken',
            userId: 'login/getUserId',
            userName: 'login/getUserName',
            layoutFlag: 'layoutFlag',
            popupModal: 'popupModal',
            popupType: 'popupType'
        }),
        appClass() {
            if (this.layoutFlag) {
                return 'defaultApp'
            }
            return 'modalApp'
        }
    },
    created() {
        let token = this.accessToken
        if (token.length > 0) {
            // check access token
            this.$store.dispatch('login/CHECK', {
                token: token,
                scb: () => {
                },
                fcb: () => {
                    this.$store.dispatch('login/LOGOUT', {serverFlag: true}).then(() => {
                        this.$router.push('/login')
                    })
                }
            })
        }
    },
    methods: {
        goDashboard() {
            if (this.$route.name !== 'dashboard') {
                this.$router.push('/dashboard')
            }
        },
        doLogout() {
            this.$store.dispatch('login/LOGOUT', {serverFlag: true}).then(() => {
                this.$router.push('/login')
            })
        },

        closePopup() {
            this.$store.dispatch('closePopup')
        },

        okPopup() {
            this.$store.dispatch('okPopup')
        },

        openChangePassword() {
            this.$store.dispatch('openChangePassword', {
                type: 'changePassword'
            })
        },
        
        changePassword() {
            this.closePopup()
        }
    }
};
</script>

<style type="text/css">
:root {
    --font-family: 'Apple SD Gothic Neo', sans-serif;
    --border-color: #D3D8DD;
    --text-primary: #333333;
    --text-secondary: #555555;
    --bg-light: #F4F6F8;
}

body {
    font: normal normal normal 16px/25px var(--font-family);
}

/* App Layout */
.defaultApp {
    background-color: #FFFFFF;
}

.modalApp {
    background-color: #F5F5F5 !important;
}

/* Typography */
.cont-title {
    padding-top: 30px;
    font: normal normal bold 28px/33px var(--font-family) !important;
    color: var(--text-primary);
}

.block-title {
    background-color: var(--bg-light);
    height: 65px;
    border-bottom: 1px solid var(--border-color);
    font: normal normal 600 20px/25px var(--font-family) !important;
    color: var(--text-primary);
}

.block-desc {
    font: normal normal normal 18px/37px var(--font-family) !important;
    color: var(--text-secondary);
}

.block-line-head {
    width: 250px;
    vertical-align: top;
    font: normal normal 600 18px/25px var(--font-family) !important;
}

.font-text-mid {
    font: normal normal normal 18px/25px var(--font-family) !important;
}

/* Border Utilities */
.block-br {
    border-right: 1px solid var(--border-color);
    color: var(--text-primary);
}

.block-bb {
    border-bottom: 1px solid var(--border-color);
    color: var(--text-primary);
}

.block-bt {
    border-top: 1px solid var(--border-color);
    color: var(--text-primary);
}

.border-table {
    --table-border: thin solid rgba(0, 0, 0, 0.12);
}

/* Table Border Styles */
.border-table table tr:first-child th {
    border: var(--table-border);
    border-right: none;
    border-bottom: none;
}

.border-table table tr th:first-child,
.border-table table tr th,
.border-table table tr td {
    border-left: var(--table-border);
}

.border-table table tr:first-child th:last-child,
.border-table table tr td:last-child {
    border-right: var(--table-border);
}

.border-table table tr:last-child td {
    border-bottom: var(--table-border);
}

.border-table table tr th.border-th-bottom {
    border-bottom: var(--table-border);
}

.border-table table tr.no-hover {
    background: transparent !important;
}
</style>
